import SpellManagePane from './SpellManagePane';

export default SpellManagePane;
export { SpellManagePane };
